import React, { useContext, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useIntl } from 'react-intl';

import { AlertContext } from 'app/shared/context';
import { useEventPageContext } from 'app/fan/context/EventPage';
import { ExpressCheckoutContextProvider } from 'app/fan/context/ExpressCheckout';
import { StripeElementsProvider } from 'app/fan/context/StripeElementsProvider';
import { BuyFlowPrePurchaseContainer } from 'app/fan/components/pages/Event/EventPages';

export const BuyFlowGuestPostPurchaseEventPage = () => {
  const { formatMessage } = useIntl();
  const { event, eventAttendee } = useEventPageContext();
  const {
    guest_last_purchased_num_tickets: guestLastPurchasedNumTicketsCookie,
  } = Cookies.get();

  const alertContext = useContext(AlertContext);

  useEffect(() => {
    let ticketsBought =
      parseInt(guestLastPurchasedNumTicketsCookie || '0') || 0;

    if (ticketsBought > 0) {
      const snackbarMessage = formatMessage({
        id: 'event.guestPostPurchase.snackbar.tickets',
      });

      alertContext.addAlert({
        message: snackbarMessage,
        type: 'success',
        id: 'guest-post-purchase-snackbar',
      });
    }

    return () => {
      ticketsBought = 0;
    };
  }, [guestLastPurchasedNumTicketsCookie]);

  // We will never run into this scenario, but include this code so that
  // Typescript knows to expect these to be present
  if (!event || !guestLastPurchasedNumTicketsCookie) {
    return null;
  }

  return (
    <StripeElementsProvider eventId={event.id}>
      <ExpressCheckoutContextProvider
        event={event}
        eventAttendee={eventAttendee}
      >
        <BuyFlowPrePurchaseContainer data-qaid="event-page-buy-flow-guest-post-purchase" />
      </ExpressCheckoutContextProvider>
    </StripeElementsProvider>
  );
};
